<template>
  <div>
    <v-text-field
      :label="label"
      :value="displayValue"
      prepend-icon="event"
      readonly
      @click="modal = true"
    ></v-text-field>

    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      persistent
      lazy
      full-width
      width="290px"
    >
      <v-date-picker :max="max" :value="isoValue" @input="onInput" scrollable>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['label', 'value', 'max'],
  data() {
    return {
      date: null,
      modal: false
    }
  },
  computed: {
    isoValue() {
      const date = this.value ? new Date(this.value) : undefined
      if (!date) return undefined
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    displayValue() {
      if (!this.value) return ''
      return new Date(this.value).toLocaleDateString(undefined, {
        timeZone: 'UTC'
      })
    }
  },
  methods: {
    onInput(val) {
      const epoch = val ? new Date(val).getTime() : undefined
      this.show = false
      this.$emit('input', epoch)
    }
  }
}
</script>

<style></style>
